import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store";
import { SessionStorage } from "@/store/session-storage";
import { SearchExternalPointResponse, SearchItem } from "@/api/external-point/response";
import { SearchExternalPointRequest } from "@/api/external-point/request";
import * as ExternalPointShopAPI from "@/api/external-point";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "external-point/search";

/**
 * 外部ポイントカード店舗一覧のデコレーター
 */
export class ListItem {
  constructor(private _item: SearchItem) {}
  get id() {
    return this._item.id;
  }
  get name() {
    return this._item.name;
  }
  get cardNumber() {
    return this._item.cardNumber;
  }
  get writeFlg() {
    return this._item.writeFlg;
  }
}

/**
 * 外部ポイントカード店舗一覧・検索API（/search-external-point）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Search extends VuexModule {
  // state
  searchRequest: SearchExternalPointRequest = {} as SearchExternalPointRequest;
  searchResponse: SearchExternalPointResponse = {} as SearchExternalPointResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.searchResponse);
  }

  get getMessage() {
    return this.searchResponse.message;
  }

  get getItems() {
    if (this.searchResponse.results) {
      return (this.searchResponse.results.items || []).map(
        i => new ListItem(i)
      );
    } else {
      return [] as ListItem[];
    }
  }

  get getTotalCount() {
    if (this.searchResponse.results) {
      return this.searchResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getSearchRequest() {
    return this.searchRequest;
  }

  // MutationActions
  @MutationAction
  async search(searchRequest: SearchExternalPointRequest) {
    const searchResponse = await ExternalPointShopAPI.search(searchRequest);
    SessionStorage.setObject(MODULE_NAME, searchRequest);
    return {
      searchRequest,
      searchResponse
    };
  }

  @MutationAction
  async restore(initial = {} as SearchExternalPointRequest) {
    const searchRequest = SessionStorage.getObject(
      MODULE_NAME,
      initial
    ) as SearchExternalPointRequest;
    return {
      searchRequest
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      searchResponse: {} as SearchExternalPointResponse
    };
  }
}

export default getModule(Search);
